import CatalogManager from "../components/CatalogManager";

export default function SuperAdminProductCategories() {
  return <CatalogManager kind="categories" />;
}
